import { Calendar, FileText, Wrench } from "lucide-react";

const HowItWorksSection = () => {
  const steps = [
    {
      number: "1",
      icon: Calendar,
      title: "Schedule Consultation",
      description:
        "Contact us to arrange a convenient time for us to visit your property and discuss your landscaping goals.",
    },
    {
      number: "2",
      icon: FileText,
      title: "Receive Written Estimate",
      description:
        "We provide a detailed, transparent estimate outlining the scope of work, materials, and costs before any project begins.",
    },
    {
      number: "3",
      icon: Wrench,
      title: "Professional Service",
      description:
        "Our experienced team completes your project with quality workmanship and attention to detail.",
    },
  ];

  return (
    <section
      data-testid="how-it-works-section"
      className="section-padding bg-white"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-[#C2410C] font-medium text-sm mb-4">
            <Calendar className="w-4 h-4" />
            Simple Process
          </span>
          <h2
            data-testid="how-it-works-headline"
            className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#1A2C22] font-bold mb-6"
          >
            How It Works
          </h2>
          <p className="text-[#4B5563] text-base md:text-lg max-w-2xl mx-auto">
            Getting started is easy. We focus on clear communication and scheduling to ensure a smooth experience.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div
              key={index}
              data-testid={`step-${index + 1}`}
              className="relative"
            >
              {/* Connector Line (hidden on mobile, last item) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-[#E5E7EB]" />
              )}

              <div className="relative bg-[#F3F4F1] rounded-2xl p-8 transition-all duration-300 hover:shadow-lg">
                {/* Step Number */}
                <div className="absolute -top-4 left-8 w-10 h-10 bg-[#2D5A27] text-white rounded-full flex items-center justify-center font-heading font-bold text-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 mt-2 shadow-sm">
                  <step.icon className="w-7 h-7 text-[#2D5A27]" />
                </div>

                {/* Content */}
                <h3 className="font-heading text-xl font-semibold text-[#1A2C22] mb-3">
                  {step.title}
                </h3>
                <p className="text-[#4B5563] text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
